export default "__VITE_ASSET__K2RKZo1___"